import { Dispatch } from 'redux';
import { getUserPermission } from '../../../api/rbac';
import { PermissionAction, ReduxPermissionActionType } from './model';
import { store } from '../../';
import { IAPIUserPermissionRsp } from '../../../model';

// 获取工作室列表
export const fetchUserPermission =
  (dispatch: Dispatch<PermissionAction>) =>
  async (
    params: { studioID?: string; gameID?: string; envID?: number } = {}
  ): Promise<IAPIUserPermissionRsp> => {
    const state = store.getState();
    const studioID = params?.studioID || state.studio.selectStudio?.studioID;
    const gameID = params?.gameID || state.games.selectGame?.gameID;
    const envID = params?.envID || state.games.selectEnv?.id;

    if (!studioID) {
      return { gamePerm: [], envPerm: [], projectPerm: [] };
    }
    const res = await getUserPermission(studioID, gameID, envID);
    if (!res) {
      return { gamePerm: [], envPerm: [], projectPerm: [] };
    }
    const info: {
      studioPrem?: { [studioID: string]: ReadonlyArray<string> };
      gamePerm?: { [gameID: string]: ReadonlyArray<string> };
      envPerm?: { [envID: string]: ReadonlyArray<string> };
    } = {};

    if (studioID) {
      info.studioPrem = { [studioID]: res.projectPerm };
    }

    if (gameID) {
      info.gamePerm = { [gameID]: res.gamePerm };
    }

    if (envID) {
      info.envPerm = { [envID]: res.envPerm };
    }

    await dispatch({
      type: ReduxPermissionActionType.SET_PERMISSION,
      result: info,
    });

    return res;
  };

export const clearUserPermission =
  (dispatch: Dispatch<PermissionAction>) => async () => {
    await dispatch({
      type: ReduxPermissionActionType.CLEAR_PERMISSION,
    });
  };
